import GLightbox from "glightbox"; 


const initImageGallery = () => {

	// The custom HTML structure for our lightboxes
	let customSlideHTML = `<div class="gslide">
		<div class="gslide-inner-content">
				<div class="ginner-container">
					<div class="gslide-media">
						<div class="gslide-description gslide-description--location">
							<div class="gdesc-inner">
								<h4 class="gslide-title"></h4>
								<div class="gslide-desc"></div>
							</div>
						</div>
					</div>
				</div>
		</div>
	</div>`;

	let galleryLinks = document.getElementsByClassName('js-image-gallery');

	if( galleryLinks.length ) {
		for (let i = 0; i < galleryLinks.length; i++) {
			var element = galleryLinks[i];

			element.addEventListener('click', function(event) {
				event.preventDefault();

				var galleryId = this.dataset.gallery;
				var itemIndex = this.dataset.galleryIndex;

				var jsImageGallery = GLightbox({
					slideHTML: customSlideHTML,
					openEffect: 'zoom',
					closeEffect: 'fade',
					loop: true,
					autoplayVideos: true,
					moreLength: 0,
					
					// gallery images
					elements: imageArr['gallery_' + galleryId],	
				});
				
				// open at specific item
				jsImageGallery.openAt( itemIndex ? itemIndex : 0 );
			});				
		}
	}

}


export default initImageGallery;